import { Grid, InputLabel, Stack, styled, Typography } from '@mui/material';
import theme from 'themes';

export const StyledLabel = styled(InputLabel)(() => ({
  width: '100%',
  fontFamily: 'SF Pro Text Regular',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '16px',
  lineHeight: '157%',
  textTransform: 'capitalize',
  color: '#3C3445',
  display: 'flex',
  '.MuiFormLabel-asterisk': {
    color: '#C44D56',
  },
  marginBottom: '5px',
}));

export const StyledSubLabel = styled(Typography)(() => ({
  fontFamily: 'SF Pro Text Regular',
  fontStyle: 'normal',
  fontWeight: '600',
  fontSize: '10px',
  textTransform: 'capitalize',
  color: '#3C3445',
  marginLeft: '-2px',
  marginTop: 'auto',
  paddingBottom: '3px',
}));

export const RequiredAsterisk = styled('span')({
  color: '#C44D56', // Red color for the asterisk
  marginLeft: '2px', // Adjust the space between the label and the asterisk if needed
});

export const StyledStack = styled(Stack)({
  gap: '6px',
});

export const StyledGrid= styled(Grid)({
  [theme.breakpoints.down('sm')]: {
    maxWidth: 'calc(100vw - 80px)',
  },
});
